// extracted by mini-css-extract-plugin
module.exports = {"login":"Login_login__3IC9Q","contentLogin":"Login_contentLogin__1ChhG","link":"Login_link__Bm8wR","signIn":"Login_signIn__31-Nk","register":"Login_register__HRbkh"};